import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { API_BASE_URL } from "../utils/constants";

// Função utilitária (Adapter) isolada na camada de dados
const parseDadosVeiculo = (dadosBrutos) => {
  if (!dadosBrutos) return "";

  try {
    // Se for uma string JSON válida, faz o parse e monta a string amigável
    const obj = JSON.parse(dadosBrutos);
    const partes = [obj.modelo, obj.cor, obj.ano].filter(Boolean);
    let textoFinal = partes.join(" - ");

    if (obj.observacoes) {
      textoFinal += ` (${obj.observacoes})`;
    }

    return textoFinal;
  } catch (e) {
    // Se não for JSON (ex: string legada antiga), retorna o texto puro como fallback
    return dadosBrutos;
  }
};

export const useCasoData = (hash, displayError) => {
  const [caseData, setCaseData] = useState(null);
  const [isAlreadyAnswered, setIsAlreadyAnswered] = useState(false);

  const fetchCaseData = useCallback(async () => {
    if (!hash) return;
    try {
      const response = await axios.get(`${API_BASE_URL}/api/v1/caso/${hash}`);

      // 🚀 PADRÃO ADAPTER: Tratamos o payload bruto aqui, na borda da aplicação
      const payloadTratado = {
        ...response.data,
        dados_bem: parseDadosVeiculo(response.data.dados_bem)
      };

      // O estado do React agora recebe o dado perfeitamente formatado
      setCaseData(payloadTratado);

      if (
        response.data.status === "respondido" ||
        response.data.status === "rejeitado"
      ) {
        setIsAlreadyAnswered(true);
      }
    } catch (error) {
      if (error.response && [403, 404].includes(error.response.status)) {
        setIsAlreadyAnswered(true);
      } else {
        displayError("Não foi possível carregar os dados do caso.");
      }
    }
  }, [hash, displayError]);

  useEffect(() => {
    fetchCaseData();
  }, [fetchCaseData]);

  return { caseData, isAlreadyAnswered, refetchCaseData: fetchCaseData };
};